/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Level_WorkingInputs */

const en_guides_level_working = /** @type {(inputs: Guides_Level_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working knowledge`)
};

const ko_guides_level_working = /** @type {(inputs: Guides_Level_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실무`)
};

const ja_guides_level_working = /** @type {(inputs: Guides_Level_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実務`)
};

/**
* | output |
* | --- |
* | "Working knowledge" |
*
* @param {Guides_Level_WorkingInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_level_working = /** @type {((inputs?: Guides_Level_WorkingInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Level_WorkingInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_level_working(inputs)
	if (locale === "ko") return ko_guides_level_working(inputs)
	return ja_guides_level_working(inputs)
});